@if (loading) {
  <db-loading-screen [ngClass]="{'hidden':!loading}" [pageBlocker]="true"></db-loading-screen>
} @else if (!woocommercePlugin?.active || !userSubscription.isEcommerce) {
  <db-ecommerce-disabled
    (onEnable)="installAndActivate()">
  </db-ecommerce-disabled>
} @else {
  <ng-container>
    <section class="main-ecommerce">
      <router-outlet></router-outlet>
    </section>
  </ng-container>
}




